import React from "react"

function Industries({ data }) {

  const { area_name } = data

  return (
    <div className="container py-3">
      <div className="row mt-4 bg-secondary px-sm-4 py-4">
        <div className="col-12">
          <h3>Great for these industries in {area_name}</h3>
          <p>CommUSA two-way radio systems are ideal for these industries in {area_name}:</p>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Education</h6>
              <p>Educators have enough to worry about without the hassle of choosing a communication system. Increase
                safety and cut costs at your school with portable and mobile two-way radios from CommUSA. Our handheld
                and
                vehicle mounted mobile two-way radios are ideal for bus management, in-school security, after- and
                before-school pick-up/drop-off communications, and more.</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Hospitality</h6>
              <p>Customer service is vital in the hospitality workplace. Our two-way radio systems keep employees
                connected to their team members and teams connected to one another. Perfect for hotel security,
                housekeeping, and maintenance staff, CommUSA’s handheld radios can help you provide better, faster
                service
                to your guests.</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Facilities</h6>
              <p>As a facilities manager, you know keeping your property secure is essential for ensuring tenants’ peace
                of mind. Improve security operations efficiency at your property with a two-way radio solution from
                CommUSA. Whether you manage offices, apartments, or homes in {area_name}, our two-way radios make
                instant communication foolproof.</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Petro/Chem Oil and Gas</h6>
              <p>Whether in the field or the office, communication is vital to the efficiency of your team. More
                importantly, quick and convenient communication helps reduce risk when workplace hazards arise. Identify
                problems faster and get everyone in the know instantly with a portable, mobile or base station two-way
                radio system from CommUSA. Plus, add on repeaters for extended coverage in large buildings, large
                campuses
                and rural locales to make sure you can always reach your team.</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Utilities &amp; Public Works</h6>
              <p>Mobile phones have been the go-to communication source for utilities and public works teams for far too
                long. Cut costs and communicate more reliably with a two-way radio system from CommUSA. We make it easy
                for you to switch with fleet vehicle installation of our mobile two-way radios. Learn for yourself why
                water districts, sanitation and utilities, and other public works departments in {area_name} are
                choosing a two-way radio solution from CommUSA.</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Public Safety</h6>
              <p>For public safety agents, effective communication means the difference between life and death. At
                CommUSA, we want to help keep your teams connected so they can focus on what they do best. To ensure you
                and your team don’t miss a beat, we also offer dispatch vehicle installation of our mobile two-way
                radios
                and a wide variety of public safety radio accessories.</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Healthcare</h6>
              <p>Seconds matter when you’re saving lives. That’s why the top hospital systems in {area_name} source
                their two-way radios from CommUSA. Your organization will never have to stress about staying connected
                and
                effectively communicating when security situations occur.</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Construction</h6>
              <p>In construction, you know time is money. Keep to your strict schedule with lightning-quick
                communication
                via CommUSA two-way radios. Direct your teams from your vehicle or office with a two-way mobile radio
                and
                base station. Or, get in on the action yourself with a portable radio durable enough to outlast even the
                toughest job sites.</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Transportation Logistics</h6>
              <p>Improve logistics performance and customer service with a mobile two-way radio and base station from
                CommUSA. We know constant communication makes the difference between happy and disgruntled customers.
                That’s why we offer fleet installation. If your airline, rail, delivery, towing, or mobile services
                teams
                need to stay on-task and on-time, you can’t go wrong with CommUSA.</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Manufacturing</h6>
              <p>With a two-way radio system from CommUSA, you can reduce downtime and improve safety at
                your {area_name} manufacturing plant. Keep in touch with security, make sure the production line stays
                efficient, and instruct work teams no matter where you are, all with your portable two-way radio.
                Additional consideration for CommUSA’s complete line of accessories that can support hands-free
                operation,
                noise cancelling headsets and remote speakers mics are routinely deployed to enhance efficiencies and
                employee safety.</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Retail / Distribution</h6>
              <p>Good customer service and fraud prevention measures make for happy retail revenues. Run price checks
                instantly, inform security of a suspicious customer, and clean up disasters faster with discrete two-way
                radio and accessory solutions from CommUSA. Find out how we’re helping the nation’s top retailers
                protect
                their bottom lines — try one of our top portable radio models today!</p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <h6 className="mb-1 strong">Events</h6>
              <p>Event managers love how easy and convenient CommUSA’s two-way portable radios make communicating at big
                events. Forget about cell phones— you need something more powerful. Let CommUSA help you speed up
                emergency responses and boost crowd control for your safest, most successful event yet.</p>
            </div>
            <div className="col-12 d-flex flex-column align-items-center">
              <h6 className="mb-1 strong text-center">Do you work for an industry we haven’t mentioned?&nbsp;</h6>
              <p className="text-center">Get in touch with our expert consultants today to find out whether a CommUSA
                two-way radio system is right for your communication needs.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Industries
